/*
 * @Author: Chao Yang
 * @Date: 2020-01-14 15:08:14
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-07-25 09:09:24
 */
import { environment } from 'src/environments/environment';
import { IColumn } from '../../model/document';

var columns = [
  {
    field: 'fileName',
    header: 'Document Name',
    width: 353,
    minWidth: 200,
  },
  {
    field: 'fund',
    header: 'Fund Name',
    width: 353,
    minWidth: 200,
  },
  {
    field: 'account',
    header: 'Account Name',
    width: 380,
    minWidth: 200,
  },
  {
    field: 'name',
    header: 'Description',
    width: 300,
    minWidth: 200,
  },
  {
    field: 'folder',
    header: 'Folder',
    width: 300,
    minWidth: 150,
  },
  {
    field: 'type',
    header: 'Type',
    width: 165,
    minWidth: 150,
  },
  {
    field: 'effective',
    header: 'Effective Date',
    width: 170,
    minWidth: 120,
  },
  {
    field: 'posted',
    header: 'Posted Date',
    width: 135,
    minWidth: 120,
  }
];
export const Columns: IColumn[] = columns;
